import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  flex: ${props => (props.collapsed ? '1' : '0.66')};
  border-right: ${props => (props.collapsed ? 'none' : '1px solid #ddd')};
  position: relative;
  ${'' /* width: 100vw; */}
  height: 100vh;
`;

const DICOMContainer = ({ collapsed, studyId, viewerToken }) => {
  // Handle the case where studyId might be undefined
  const sanitizedStudyId = studyId ? studyId.replace(/\s+/g, '') : '';
  const iframeUrl = process.env.REACT_APP_VIEWER_URL || 'https://uatpacs.natoe.ai';

  return (
    <Container collapsed={collapsed}>
      <iframe
        src={`${iframeUrl}?token=${viewerToken || ''}&study=${sanitizedStudyId}`}
        title="Study Viewer"
        style={{ width: '100%', height: '100%', borderRadius: '1rem' }}
      />
    </Container>
  );
};

export default DICOMContainer; 